export default __webpack_public_path__ + "static/media/home-page-bg.03e7df5e.png";